import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import dayjs from "dayjs";
import { addDriverCall, getDriverCalls } from "../../utils/DriverCall/driverCallsApi";
import {
    ADD_DRIVER_CALL_REQUEST,
    GET_DRIVER_CALLS_REQUEST,
    addDriverCallSuccess,
    addDriverCallFailure,
    getDriverCallsSuccess,
    getDriverCallsFailure,
} from "../../redux/actions/driverCallsAction";

function* handleAddDriverCall(action: any): any {
    try {
        const response = yield call(addDriverCall, action.payload);
        if (response?.data?.status === 200) {
            yield put(addDriverCallSuccess(response.data.message || "Data Created"));
        } else {
            yield put(addDriverCallFailure(response?.data?.message || "Failed to save driver call"));
        }
    } catch (error: any) {
        yield put(addDriverCallFailure(error?.response?.data?.message || error.message || "Something went wrong"));
    }
}

function* handleGetDriverCalls(action: any): any {
    try {
        const { fromdate, todate, signal } = action.payload;
        const response = yield call(getDriverCalls, fromdate, todate, signal);

        const payload = response?.data;
        const raw = Array.isArray(payload)
            ? payload
            : payload?.data?.ResponseData
                || payload?.data?.data
                || payload?.data?.result
                || payload?.data?.rows
                || payload?.data?.items
                || payload?.ResponseData
                || payload?.result
                || payload?.rows
                || payload?.items
                || [];

        const list = raw.map((item: any) => ({
            ...item,
            id: item.drcallid ?? item._id,
            date: item.date
                ? dayjs(item.date).format("YYYY-MM-DD hh:mm A")
                : "",
        }));

        yield put(getDriverCallsSuccess(list, response?.data?.data?.tablelength ?? list.length));
    } catch (error: any) {
        if (axios.isCancel(error)) return;
        yield put(getDriverCallsFailure(error?.response?.data?.message || error.message || "Failed to fetch driver calls"));
    }
}

export default function* driverCallsSaga() {
    yield takeLatest(ADD_DRIVER_CALL_REQUEST, handleAddDriverCall);
    yield takeLatest(GET_DRIVER_CALLS_REQUEST, handleGetDriverCalls);
}